export default __webpack_public_path__ + "235ddce9d267930a63d642ecb26ab707.svg";